export default {"src":"/_next/static/media/faq-icon1.fa497fb8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};